import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventService, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CmsPuffComponent, UserSelectContentTypes } from '../../../core/model';
import { UserSelectContentEvent } from '../../../core/user';

@Component({
  selector: 'py-puff',
  templateUrl: './puff.component.html',
  styleUrls: ['./puff.component.scss'],
  standalone: false,
})
export class PuffComponent implements OnInit {
  styleClasses: string;
  isReadMoreExpanded = false;
  puffId: string;
  data$: Observable<CmsPuffComponent>;

  @HostListener('document:click', ['$event'])
  onLinkItemClick(event) {
    const target = event?.target;

    if (this.windowRef.isBrowser() && target) {
      if (this.elementRef?.nativeElement?.contains(target)) {
        this.eventService.dispatch(new UserSelectContentEvent(target, UserSelectContentTypes.PUFF, this.puffId));
      }
    }
  }

  constructor(
    public component: CmsComponentData<CmsPuffComponent>,
    protected router: Router,
    private elementRef: ElementRef,
    private eventService: EventService,
    private windowRef: WindowRef
  ) {}

  ngOnInit(): void {
    this.styleClasses = this.elementRef.nativeElement.className || 'puff-collection-default-list';

    this.data$ = this.component.data$.pipe(tap((data) => (this.puffId = data?.uid)));
  }

  hasList(type) {
    return this.styleClasses?.split && this.styleClasses?.split(' ').includes(type);
  }

  showReadMore() {
    return this.styleClasses?.split && this.styleClasses?.split(' ').includes('paragraph-read-more');
  }

  getTarget(data: CmsPuffComponent): string | null {
    return data.linkTarget === 'true' || data.linkTarget === true ? '_blank' : null;
  }

  getReadMoreExpanded() {
    if (!this.showReadMore()) {
      return true;
    }

    return this.isReadMoreExpanded;
  }

  toggleReadMore() {
    this.isReadMoreExpanded = !this.isReadMoreExpanded;
  }
}
